import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import api from "../services/AxiosInstance";
import { setTenant, clearTenant } from "../store/slices/tenantSlice";
import { fetchMyPermissionsThunk,clearPermissions } from "../store/slices/permissionSlice";
import { fetchTenantTreeThunk } from "../store/slices/userPanchayathAssignSlice";

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':            
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

// src/services/AuthService.js

/**
 * Auto-login on refresh.
 * - If no token/user => go login
 * - If normal user => setTenant from user.pan_id
 * - If superadmin => load tenant-tree + permissions, keep tenant empty (until selected)
 */
// src/services/AuthService.js


const safeJson = (v, fallback = null) => {
  try {
    return JSON.parse(v);
  } catch {
    return fallback;
  }
};

export const checkAutoLogin = async (dispatch, navigate) => {
  try {
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");

    if (!token || !userStr) {
      dispatch(clearTenant());
      dispatch(clearPermissions());
      navigate("/login", { replace: true });
      return;
    }

    const user = safeJson(userStr, null);
    if (!user) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      dispatch(clearTenant());
      dispatch(clearPermissions());
      navigate("/login", { replace: true });
      return;
    }

    const role = String(user?.role || "").toLowerCase();
    api.defaults.headers.common.Authorization = `Bearer ${token}`;

    // ✅ helper: do we already have a tenant selected (user changed it manually)?
    const lsPanActive = Number(localStorage.getItem("pan_id_active") || 0);
    const lsPanIds = safeJson(localStorage.getItem("pan_ids"), []);
    const hasSavedTenant =
      lsPanActive > 0 || (Array.isArray(lsPanIds) && lsPanIds.length > 0);

    // ✅ Normal user
    if (role !== "superadmin") {
      const pan_id = Number(user?.pan_id || 0);
      if (!pan_id) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        dispatch(clearTenant());
        dispatch(clearPermissions());
        navigate("/login", { replace: true });
        return;
      }

      // ✅ ONLY set tenant if nothing is already selected
      if (!hasSavedTenant) {
        dispatch(
          setTenant({
            pan_id,
            pan_ids: [pan_id],
            pan_id_active: pan_id,
            pan_name: user?.pan_name || "Panchayath",
          })
        );
      }

      // ✅ permissions (will use current tenant from store/localStorage)
      await dispatch(fetchMyPermissionsThunk()).unwrap();

      if (window.location.pathname === "/login") {
        navigate("/dashboard", { replace: true });
      }
      return;
    }

    // ✅ Superadmin: load tenant tree, don't overwrite tenant
    await dispatch(fetchTenantTreeThunk()).unwrap();

    if (window.location.pathname === "/login") {
      navigate("/dashboard", { replace: true });
    }
    return;
  } catch (e) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(clearTenant());
    dispatch(clearPermissions());
    navigate("/login", { replace: true });
  }
};


export const isLogin = () => !!localStorage.getItem("token");
